import React, { PureComponent } from "react";
import Input from "antd/lib/input";
import List from "antd/lib/list";

class WordSearch extends PureComponent {
  state = {
    searchTerm: ""
  };

  render() {
    const { searchTerm } = this.state;
    const { words, listID, wordIDs } = this.props;
    let foundWords = [];
    if (searchTerm) {
      foundWords = words.filter(word => {
        let lowerCaseParam = searchTerm.toLowerCase();
        const isPattern = lowerCaseParam.includes("=");
        let keys = Object.keys(word);
        if (isPattern) {
          keys = [lowerCaseParam.split("=")[0]];
          lowerCaseParam = lowerCaseParam.split("=")[1];
        }
        let includes = false;
        keys.filter(key => key !== "levelID" && key !== "key").forEach(key => {
          if (typeof word[key] === "string") {
            if (word[key].toLowerCase().includes(lowerCaseParam)) {
              includes = true;
            }
          } else if (word[key] == lowerCaseParam) {
            includes = true;
          }
        });
        const alreadyListed = wordIDs.indexOf(word.id) !== -1;
        return includes && !alreadyListed;
      });
    }

    return (
      <div>
        <div>
          <Input
            placeholder="Search Word"
            value={searchTerm}
            onChange={e => this.setState({ searchTerm: e.target.value })}
          />
        </div>
        {foundWords.length > 0 && (
          <List
            header={<b>Search Results</b>}
            bordered
            dataSource={foundWords.slice(0, 10)}
            renderItem={word => {
              return (
                <List.Item
                  actions={[
                    <a
                      onClick={() => {
                        this.props.addWordToList(listID, word.id);
                        this.setState({ searchTerm: "" });
                      }}
                    >
                      add
                    </a>
                  ]}
                >{`ID: ${word.id} | DE: ${word.de} | EN: ${word.en} | TR: ${
                  word.tr
                }`}</List.Item>
              );
            }}
          />
        )}
      </div>
    );
  }
}

export default WordSearch;



// WEBPACK FOOTER //
// ./src/containers/Lists/WordSearch/index.jsx